<!--
 * @Author: xiaokun
 * @Date: 2020-03-02 14:21:35
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-13 17:22:49
 * @Description: 新建企业活码/编辑企业活码
 -->
<template>
  <div class="add-edit-code">
    <div class="content">
      <!-- 顶部信息 -->
      <div class="header-box">
        <div
          class="go-back cursor"
          @click="goBack"
        >
          <mk-iconfont
            icon-class="left"
            class="icon"
          ></mk-iconfont>
          <span>返回</span>
        </div>
        <div class="header-title">
          {{ isEdit ? '编辑企业活码': '新增企业活码' }}
        </div>
      </div>
      <!-- 步骤条 -->
      <mk-steps
        :active="activeIndex"
        finish-status="success"
        align-center
        :space="140"
        class="code-step"
      >
        <mk-step
          title="基本信息"
        ></mk-step>
        <mk-step title="中间页"></mk-step>
        <mk-step title="生成活码"></mk-step>
      </mk-steps>
      <!-- 内容 -->
      <step-one
        v-show="activeIndex === 0"
        ref="codeStepOne"
        :is-edit="isEdit"
        class="step-item"
      />
      <step-two
        v-show="activeIndex === 1"
        ref="codeStepTwo"
        :is-edit="isEdit"
        :active-index="activeIndex"
        class="step-item"
      />
      <step-three
        v-show="activeIndex === 2"
        ref="codeStepThree"
        class="step-item"
        :is-edit="isEdit"
        :link-url="linkUrl"
        :qrcode-url="qrcodeUrl"
      />
    </div>
    <!-- 底部操作 -->
    <div class="handle">
      <template v-if="activeIndex === 0">
        <!-- 第一步 -->
        <mk-button-biz @click="goBack">
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          @click="nextToTwo"
        >
          下一步
        </mk-button-biz>
      </template>
      <!-- 第二步 -->
      <template v-if="activeIndex === 1">
        <mk-button-biz @click="prevToOne">
          上一步
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          @click="nextToThree"
        >
          下一步
        </mk-button-biz>
      </template>
      <!-- 创建成功 -->
      <template v-if="activeIndex === 2">
        <mk-button-biz
          type="primary"
          @click="allReady"
        >
          完成
        </mk-button-biz>
      </template>
    </div>
  </div>
</template>
<script>
import stepOne from '../components/step-one'
import stepTwo from '../components/step-two'
import stepThree from '../components/step-three'
export default {
  name: 'AddEditCode',
  components: { stepOne, stepTwo, stepThree },
  props: {},
  data () {
    return {
      // 是否为编辑
      isEdit: false,
      // 编辑时 活码id
      codeId: '',
      // 当前步骤
      activeIndex: 0,
      formData: {},
      // 活码链接，文字复制版
      linkUrl: '',
      // 活码二维码生成的链接
      qrcodeUrl: ''
    }
  },
  watch: {},
  created () {
    // 如果路径携带codeId参数，表示为编辑状态，调用请求活码详情接口回显数据
    if (this.$route.query.codeId) {
      this.isEdit = true
      this.codeId = this.$route.query.codeId
      this.getCodeData(this.codeId)
    }
  },
  mounted () {},
  methods: {
    // 返回/取消
    goBack () {
      // 如果为第三页，直接返回首页
      if (this.activeIndex === 2) {
        history.go(-1)
      } else {
        this.$confirm('内容将不会被保存', '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'none'
        }).then(() => {
          history.go(-1)
        })
      }
    },
    // 点击下一步，准备前往第二步
    async nextToTwo () {
      // 校验第一步表单信息是否填写
      let valid = await this.$refs.codeStepOne.submitForm()

      if (valid) {
        // 获取第一步表单数据
        let backdata = this.$refs.codeStepOne.getData()
        this.formData = {
          ...backdata
        }
        // 前往第二步
        this.activeIndex = 1
      }
    },
    // 点击下一步，准备前往第三步
    nextToThree () {
      // 校验第二步表单信息是否填写
      let valid = this.$refs.codeStepTwo.submitForm()
      if (valid) {
      // 获取第二步表单填写数据
        let backdata = this.$refs.codeStepTwo.getData()
        this.formData = {
          ...this.formData,
          ...backdata
        }
        if (this.isEdit) {
        // 编辑更新
          this.upDateCode(this.formData)
        } else {
          // 调用新建接口
          this.createCode(this.formData)
        }
      }
    },
    // 返回第一步
    prevToOne () {
      this.activeIndex = 0
    },
    // 完成
    allReady () {
      history.go(-1)
    },
    // 新建活码接口
    /**
     * 新建活码逻辑：1. 传递表单填写的参数，走新建接口 提交至后台
     * 2. 新建接口会返回该活码所有信息，包含活码ID
     * 3. 将活码 id 以及C端所需要的参数 拼接成 URL 生成活码的C端地址,生成第三步 所展示的二维码及复制链接
    */
    async createCode (params) {
      // 删除不必要参数
      // 创建活码
      let res = await MKMATERIALSVC.QrCodeApi.qrcodePost(params)
      if (res.success) {
        this.jointLink(res.data)
      }
    },
    // 更新活码接口
    async upDateCode (params) {
      // 删除不必要参数
      if (params.rule === 1) {
        delete params['limit']
      }
      let res = await MKMATERIALSVC.QrCodeApi.qrcodePut(params)
      let qrcodeUrl = ''
      if (res.success) {
        this.jointLink(params)
      }
    },
    // 活码链接拼接，第三步展示内容
    async jointLink (data) {
      const { linkUrl, qrcodeUrl } = this.util.createH5Url(data, 'qrcode', this.$projectScene, true)
      // 活码链接，文字版 可复制
      this.linkUrl = linkUrl
      // 活码二维码的链接，第三步展示
      this.qrcodeUrl = qrcodeUrl
      // 调用第三步二维码生成图片
      await this.$refs.codeStepThree.createQrcodeUrl(this.qrcodeUrl)
      // 跳转至第三步
      this.activeIndex = 2
    },

    // 编辑表单时，获取表单数据进行回显
    async getCodeData (_id) {
      let params = {
        codeID: _id
      }
      let res = await MKMATERIALSVC.QrCodeApi.qrcodeGetGet(params)
      if (res.success) {
        this.formData = res.data
        this.$refs.codeStepOne.setData(res.data)
        this.$refs.codeStepTwo.setData(res.data)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.add-edit-code {
  text-align: center;
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  /deep/.el-icon-circle-close::after {
    display: none !important;
  }

  .content {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    // 顶部信息
    .header-box {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      box-shadow: 0 -1px 0 0 #e8e8e8 inset;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      font-size: 14px;

      .go-back {
        display: flex;
        align-items: center;

        /deep/ .icon-mk-left {
          color: #000;
          font-size: 18px;
          margin-right: 5px;
        }
      }

      .header-title {
        margin-left: 32px;
      }
    }
    // 步骤条
    .code-step {
      padding: 32px 0 42px;
      justify-content: center;

      // is-process 填写中的步骤条样式；is-success 填写完成的步骤条样式
      /deep/ .el-step__head {
        .el-step__icon.is-text {
          border-color: #e5e5e5;
          background: #e5e5e5;
          color: #595959;
        }

        .el-step__line {
          height: 1px;
          margin: 0 20px !important;
        }
      }

      /deep/ .el-step__head.is-process {
        .el-step__icon.is-text {
          border-color: #009cff;
          background: #009cff;
          color: #fff;
        }
      }

      /deep/ .el-step__head.is-success {
        .el-step__line {
          background-color: #009cff;

          .el-step__line-inner {
            border-color: #009cff;
          }
        }

        .el-step__icon.is-text {
          border-color: #ccecff;
          background: #ccecff;
          color: #009cff;
        }
      }

      /deep/ .el-step__main {
        .el-step__title {
          font-size: 14px;
        }

        .el-step__title.is-success {
          color: #595959;
        }

        .el-step__title.is-wait {
          color: #8c8c8c;
        }
      }
    }
    // 内容
    .step-item {
      text-align: center;
      margin: 0 auto;
    }

    /deep/ .el-form-item {
      margin-bottom: 13px;

      .el-form-item__label {
        line-height: 42px;
        font-size: 13px;
        color: #262626;
      }

      .el-form-item__content {
        max-width: 320px;

        .el-tag {
          margin: 4px 0 2px 6px;
        }

        .el-input__inner {
          padding: 0 8px;
        }

        .el-textarea__inner {
          padding: 5px 8px;
        }

        .el-input__count-inner {
          color: #bfbfbf;
        }

        .el-textarea {
          .el-input__count {
            background: transparent;
            height: 30px;
          }
        }

        .el-input--small {
          .el-input__inner {
            padding: 0 50px 0 15px;
          }
        }
      }

      .el-radio-group {
        margin-top: 14px;

        .el-radio__label {
          font-weight: 400;
          font-size: 14px;
        }
      }
    }
  }
  // 底部操作
  .handle {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
  }
}
</style>
